import { Box, CardActionArea, Typography } from '@mui/material';
import { clsx } from 'clsx';
import './rectangle.scss';

export type RectangleBoxItem = {
  id?: number;
  key?: string;
  color: string;
};
interface RectangleBoxProps {
  bgColor: string;
  label: string;
  index: number;
  showPriority?: boolean;
  pvqHover?: string;
  pvqKey?: string;
}

const RectangleBox = (props: RectangleBoxProps) => {
  const { label, bgColor, index, pvqHover, showPriority = true, pvqKey = '' } = props;

  return (
    <CardActionArea className='cardActionArea'>
      <Box
        className={clsx('rectangleBox', pvqHover === pvqKey ? 'animationRectangle' : '')}
        bgcolor='background.light'
      >
        <Box
          className={clsx('square', pvqHover === pvqKey ? 'squareActive' : 'squareDiActive')}
          sx={{ backgroundColor: bgColor }}
        />
        <Typography
          color={pvqHover === pvqKey ? 'white' : 'text.darker'}
          className='labelStyle'
          sx={{ right: pvqHover === pvqKey ? '-12px' : '0' }}
        >
          {showPriority ? `${index + 1}.${label}` : label}
        </Typography>
      </Box>
    </CardActionArea>
  );
};

export default RectangleBox;
